import React from "react";
import PageContainer from "../../../../hoc/PageContainer";
import { Image } from 'semantic-ui-react';
import "./Rcc.css";

import IMG1 from "../../img/2122-service-1/2122-service-1-1-min.jpg";
import IMG2 from "../../img/2122-service-1/2122-service-1-2-min.jpg";
import IMG3 from "../../img/2122-service-1/2122-service-1-3-min.jpg";
import IMG4 from "../../img/2122-service-1/2122-service-1-4-min.jpg";
import IMG5 from "../../img/2122-service-1/2122-service-1-5-min.jpg";

const Rcc = () => (
  <PageContainer page="ourServices">
    <h1 className="AboutUsTitle">
      Rotary Club of Central - RCC 屯門天主教中學助學金計劃
    </h1>
    <br />
    <div className="AboutUsImage">
      <Image className="AboutUsImage" src={IMG1} />
    </div>
    <div className="AboutUsText">
      <p>
        中區扶輪社一直以來透過「Adopt a School」計劃，關顧屯門天主教中學中學生的學習和升學情況。據本社和校方了解，現今一些基層中學生也需做兼職來幫補家計，以致有一些勤奮向上的學生，由於花太長時間在一些快餐店兼職，沒有足夠時間溫習功課而影響他們的學業成績，甚至升學機會。中區扶輪社有見及此，今年啟動這個助學計劃，撥資聘請由校方推薦的基層中學生為區內的基層小學生補習，希望透過計劃，那些基層中學生可以賺取生活費之餘，亦可以有足夠時間和精神溫習功課，又可以幫助區內基層小學生改善他們的學業成績，可謂一舉三得！
        <br />
        <br />
        受惠中學生： 10人
        <br />
        受惠小學生:
        <br />
        青山天主教小學： 25人
        <br />
        仁德天主教小學： 14人
        <br />
        領取綜援家庭學生
        <br />
        單親家庭學生
        <br />
        有學業援助需要學生
      </p>
    </div>
    <div className="AboutUsImage">
      <Image className="AboutUsImage" src={IMG2} />
    </div>
    <br /><br />
    <div className="AboutUsImage">
      <Image className="AboutUsImage" src={IMG3} />
    </div>
    <br /><br />
    <div className="AboutUsImage">
      <Image className="AboutUsImage" src={IMG4} />
    </div>
    <br /><br />
    <div className="AboutUsImage">
      <Image className="AboutUsImage" src={IMG5} />
    </div>
    <br /><br />
  </PageContainer>
);

export default Rcc;
